import { render } from "./RedirectToCab.vue?vue&type=template&id=316c9c3a&scoped=true"
import script from "./RedirectToCab.vue?vue&type=script&lang=js"
export * from "./RedirectToCab.vue?vue&type=script&lang=js"

import "./RedirectToCab.vue?vue&type=style&index=0&id=316c9c3a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316c9c3a"]])

export default __exports__